
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <b>Durch gesundes Essen den Alterungsprozess zu verzögern, erhoffen sich viele Menschen mittleren Alters. Ist dies überhaupt möglich?</b><br />
Ja, wir wissen seit über 100 Jahren, dass weniger Essen («Kalorienrestriktion») das Leben so gut wie aller getesteten Organismen und Tiere verlängert. Inzwischen hat man herausgefunden, dass es einen Nährstoff gibt, der den Alterungsprozess ankurbelt: Es ist das Protein oder Eiweiss. Vor allem tierisches Eiweiss in Form von Fleisch oder Milch erscheint mir ungünstig. Diese Lebensmittel kurbeln Wachstumsprozesse an, und Wachstum geht einher mit Alterung. Um den Alterungsprozess zu bremsen, müssen Sie den Körper vom Wachstums- in den Wartungsmodus überführen. Das geht durch weniger essen – oder durch eine hauptsächlich pflanzliche Kost.
    <b>Gute Fette in Nüssen oder Ölen werden momentan von vielen Ernährungsfachleuten als Gesundmacher gepriesen.</b><br />
Gute Fette sind sehr empfehlenswert, das gilt insbesondere auch für Nüsse. Eine Handvoll Nüsse täglich senkt das Sterblichkeitsrisiko deutlich, das geht aus diversen Studien hervor. Ich kann nur zum Nusskonsum raten! Die meisten Öle sind ebenfalls sehr empfehlenswert, in erster Linie vielleicht Olivenöl, Rapsöl und Leinöl.
    <b>Zucker steht dagegen bei den meisten Fachleuten sehr schlecht da. Aber macht hier nicht auch die Menge das Gift?</b><br />
Doch, klar. Das Problem aber ist, dass wir die Mindestmenge bei weitem überschreiten. Wir essen viel zu viel Zucker. Das liegt nicht an dem kleinen Löffel Zucker, den wir uns in den Kaffee rühren. Es liegt an dem versteckten Zucker in den verarbeiteten Lebensmitteln. Eine Dose Cola ist schon zu viel Zucker! Aber Zucker ist ja auch in Fruchtjoghurts oder Bio-Tomatensaucen, die wir für gesund halten. Oder in diversen Müesli-Sorten. Das Problem ist nicht das Dessert, das man immer wieder mal geniessen kann. Das Problem ist, wenn bereits unser Frühstück mit dem Dessert beginnt.
    <b>Warum ist es für uns so schwierig, auf Zucker zu verzichten?</b><br />
Mir fällt es gar nicht so schwer. Man muss sich ein bisschen entwöhnen, dann geht es.
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;